export const ADJUST_LINK = 'https://habio.go.link/p';
export const ADJUST_TOKEN = 'uxh87rl';

export const APP_NAME = 'Habio';
